(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kr-compatible-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kr-compatible-models')) {
    customElements.define('kr-compatible-models', class extends HTMLElement {
      connectedCallback() {
        const sortModels = () => {
          const collator = new Intl.Collator('fi', { numeric: true, sensitivity: 'base' });
          const models = Array.from(this.children);
          models.sort((a, b) => collator.compare(a.textContent.trim(), b.textContent.trim()));
          this.append(...models);
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', sortModels, { once: true });
        } else {
          sortModels();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
